import { Component, OnInit } from '@angular/core';
import { BuildInfo } from '../model/build-info';
import { ApiService } from '../services/api.service';
import { environment } from 'src/environments/environment';
import { EnvConfigurationService } from '../services/config/env-configuration.service';
import { ErrorHelper } from '../common/ErrorHelper';
import { NotifierService } from 'angular-notifier';
import { AppComponent } from '../app.component';
import { User } from '../model/user';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  title = 'OVI';
  /* use for main nav*/
  active = 1;

  user = new User();

  buildInfo = new BuildInfo();

  constructor(
    public apiService: ApiService,
    public notifierService: NotifierService,
    public app: AppComponent,
    public router: Router
  ) {
  }

  isActiveMenu(menuRoute: string): boolean {
    return this.router.url === menuRoute || this.router.url.startsWith(menuRoute);
  }


  isActiveSubMenu(subMenuRoutes: string[]): boolean {
    return subMenuRoutes.some(route => this.router.url === route || this.router.url.startsWith(route));
  }


  ngOnInit(): void {
    this.app.getUserData().then(user => {
      this.user = user;
    });
    this.buildInfo.frontendVersion = environment.appVersion;
    this.apiService.getBuildInfo().toPromise().then(
      data => {
        this.buildInfo.backendVersion = data.application.version;
        this.buildInfo.backendTimestamp = data.lastUpdated;
        this.buildInfo.appPackageVersion = EnvConfigurationService.configuration.APP_PACKAGE_VERSION;
        this.buildInfo.configPackageVersion = EnvConfigurationService.configuration.CONFIG_PACKAGE_VERSION;
        this.buildInfo.deploymentTime = EnvConfigurationService.configuration.DEPLOYMENT_TIME;
      },
      (error) => {
        const errorMessage = ErrorHelper.disectError('get version', error);
        this.notifierService.notify('error', errorMessage);
      });
  }
}
